// extracted by mini-css-extract-plugin
export var articleContent = "HappeningPage-module--articleContent--ddf22";
export var articleHeader = "HappeningPage-module--articleHeader--a4994";
export var date = "HappeningPage-module--date--90c75";
export var eventLink = "HappeningPage-module--eventLink--f0005";
export var image = "HappeningPage-module--image--82757";
export var imageWrapper = "HappeningPage-module--imageWrapper--e540e";
export var publishedDate = "HappeningPage-module--publishedDate--037d4";
export var readMoreArticles = "HappeningPage-module--readMoreArticles--de2d7";
export var tag = "HappeningPage-module--tag--5a8f7";